interface XpFlyupProps {
  xp: number;
}

export function XpFlyup({ xp }: XpFlyupProps) {
  if (xp <= 0) return null;

  return (
    <span className="animate-xp-flyup pointer-events-none inline-block text-lg font-extrabold text-amber-500">
      +{xp} XP
    </span>
  );
}
